
import {defineComponent} from "vue";

export default defineComponent({
    name: "EChatButton",
    props: {
        id: {
            type: String,
            required: true,
        },
        isBottom: {
            type: Boolean,
            required: false,
            default: true
        },
        section: {
            type: String,
            required: false,
            default: ""
        },
    },
    computed: {
        eChatClasses(): Record<string, boolean> {
            return {
                eChat: true,
                bottom: this.isBottom,
                middle: !this.isBottom
            }
        },
    },
    mounted() {
        const eChatElement = this.$refs.eChatRef as HTMLElement;
        if ((eChatElement) && (this.section)) {
            const args = {section: this.section.split(" ")};
            const loadLpTag = () => {
                const lpTag = (window as any).lpTag;
                if (lpTag && typeof lpTag.newPage === "function") {
                    lpTag.newPage(window.location.href, args);
                } else {
                    setTimeout(loadLpTag, 1000);
                }
            };
            loadLpTag();
        }
    },
    methods: {
    },
});
